//
// Generated class Integrator
//

/// <reference path="Integrator_ManagedObject.ts" />

enum IntegratorType
{
    IntegratorTypeSAP         = "sap",
    IntegratorTypeMailchimp   = "mailchimp",
    IntegratorTypeDB58        = "db58",
    IntegratorTypeReplica     = "replica",
    IntegratorTypeBridge      = "bridge",
    IntegratorTypeUlyses      = "ulyses",
    IntegratorTypeWineAdvisor = "wine-advisor",
    IntegratorTypeTicketBAI  = "ticket-bai",
    IntegratorTypeVeriFactu  = "veri-factu",
    IntegratorTypeEmaar      = "emaar",
    IntegratorTypeWhatsapp   = "whatsapp",
    IntegratorTypeSMTPEmail  = "smtp-email",
    IntegratorTypeMailersend = "mailersend",
    IntegratorTypeDualLinkPurchaseOrder = "dl-purchase-order",
    IntegratorTypeMozrest    = "mozrest",
    IntegratorTypeOpera      = "opera",
    IntegratorTypeCloudLevanteOCR = "cloud-levante-ocr",
    IntegratorTypeWebhook    = "webhook"
}

class Integrator extends Integrator_ManagedObject
{

}
